// 미디어 센터 섹션 탭 — /blog(전체)와 /blog/:section 이 공유한다.
import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { ALL_TAB, TAB_GROUPS } from './mediaSections';
import styles from './MediaCenter.module.css';

function Tab({ tab, active }) {
  return (
    <Link
      to={tab.path}
      className={`${styles.tab} ${active ? styles.tabActive : ''}`}
      aria-current={active ? 'page' : undefined}
    >
      {tab.label} <span className={styles.tabCount}>{String(tab.count).padStart(2, '0')}</span>
    </Link>
  );
}

/** @param {{ activeSlug?: string|null }} props activeSlug 가 null 이면 '전체' 탭이 활성. */
export function MediaTabs({ activeSlug = null }) {
  return (
    <nav className={styles.tabs} aria-label="미디어 센터 섹션">
      <div className={styles.tabsGroup}>
        <Tab tab={ALL_TAB} active={activeSlug === null} />
      </div>
      {TAB_GROUPS.map(({ group, tabs }) => (
        <Fragment key={group}>
          <span className={styles.tabDivider} aria-hidden="true" />
          <div className={styles.tabsGroup}>
            {tabs.map((tab) => (
              <Tab key={tab.slug} tab={tab} active={tab.slug === activeSlug} />
            ))}
          </div>
        </Fragment>
      ))}
    </nav>
  );
}
